import DoughnutDataset from "../components/Charts/Doughnut/types/DoughnutDataset";
import ChartData from "../components/Charts/types/ChartData";
import fetchPlus from "../lib/fetchPlus/fetchPlus";
import { Action } from "../types/Action";
import { ActivityDetail } from "../types/API/activity/ActivityDetail";

import { ApiResponse } from "../types/API/ApiResponse";
import { TotalPunctual } from "../types/TotalPunctual";

type VisitTotals = {
    calloutsYTD: {
        amount: number;
        total: number;
    };
    routinesYTD: {
        amount: number;
        total: number;
    };
    followupsYTD: {
        amount: number;
        total: number;
    };
};

type RecentPestActivity = {
    VisitID: string;
    SiteName: string;
    SiteRef: string;

    CardNumber: string;
    CustomerSiteNumber: string;

    DateDifference: string;
    DateServiceEnd: string;
    PestType: string;
};

const dashboardService = {
    /** Top 3 donuts for actions */
    getAllDashboardActions: () =>
        fetchPlus<ApiResponse<"donutData", DoughnutDataset[]>>(
            `${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/actions/by-all-types`,
            "GET"
        ),

    /** Actions listing on dash */
    getHighPriorityActionsByRag: () =>
        fetchPlus<ApiResponse<"actions", Action[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions?type=PRIORITY`, "GET"),
    getLongestOpenActions: () =>
        fetchPlus<ApiResponse<"actions", Action[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/actions?type=OLDEST`, "GET"),

    /** Charts */
    getPestActivityPCMGraphData: () =>
        fetchPlus<ApiResponse<"chartData", ChartData>>(
            `${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/activity/pest-activity-by-month`,
            "GET"
        ),
    getPestActivityGraphYTDData: () =>
        fetchPlus<ApiResponse<"chartData", ChartData>>(
            `${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/activity/pest-activity-data-ytd`,
            "GET"
        ),
    getPestActivityDetailYTDData: () =>
        fetchPlus<ApiResponse<"detail", ActivityDetail[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/activity/details?type=PEST`, "GET"),

    /* Visits */
    getVisitTotals: () =>
        fetchPlus<ApiResponse<"visitTotals", VisitTotals>>(`${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/visit-totals`, "GET"),
    getRecentPestActivity: () =>
        fetchPlus<ApiResponse<"activity", RecentPestActivity[]>>(`${process.env.NEXT_PUBLIC_EXT_API_URL}/activity?type=RECENT`, "GET"),

    /** Selected site Visit donuts */
    getVisitsByFollowUp: () =>
        fetchPlus<ApiResponse<"count", TotalPunctual>>(`${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/visits/by-follow-up`, "GET"),
    getVisitsByRoutines: () =>
        fetchPlus<ApiResponse<"count", TotalPunctual>>(`${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/visits/by-routines`, "GET"),
    getVisitsByCallouts: () =>
        fetchPlus<ApiResponse<"count", TotalPunctual>>(`${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/dashboard/visits/by-callouts`, "GET"),
};

export default dashboardService;
